var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLudzie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10,10)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.197,32.02C37.08,27.648 26.942,33.685 26.751,42.269C26.452,55.6 47.619,60.671 51.962,48.93",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.313,30.343C49.372,22.219 37.935,19.319 31.73,25.253C22.092,34.469 33.474,53.023 44.847,47.79",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.528,34.194C61.9,27.076 55.863,16.939 47.28,16.747C33.948,16.448 28.877,37.616 40.618,41.958",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2,41.306C67.325,39.365 70.224,27.928 64.29,21.723C55.074,12.085 36.521,23.467 41.753,34.84",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.351,47.521C62.469,51.894 72.606,45.856 72.798,37.273C73.097,23.941 51.929,18.87 47.587,30.611",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.236,49.194C50.177,57.318 61.614,60.217 67.82,54.283C77.458,45.068 66.075,26.514 54.703,31.746",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.024,45.352C37.651,52.469 43.688,62.606 52.272,62.798C65.604,63.097 70.674,41.929 58.933,37.587",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.35,38.236C32.225,40.177 29.326,51.614 35.26,57.82C44.476,67.458 63.029,56.075 57.797,44.703",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.962,36.36C39.212,34.923 36.282,34.554 33.71,36.311C31.092,38.098 29.895,41.836 32.084,44.274",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.957,31.123C45.735,28.869 43.924,26.537 40.863,25.96C37.748,25.373 34.259,27.17 34.083,30.441",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.191,30.959C54.627,29.208 54.996,26.278 53.239,23.706C51.452,21.088 47.715,19.892 45.276,22.081",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.422,35.953C60.675,35.731 63.008,33.921 63.585,30.86C64.172,27.744 62.375,24.256 59.103,24.079",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.586,43.184C60.336,44.62 63.266,44.989 65.838,43.232C68.456,41.445 69.652,37.708 67.464,35.27",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.592,48.415C53.814,50.669 55.625,53.001 58.686,53.578C61.801,54.165 65.29,52.368 65.466,49.097",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.36,48.586C44.923,50.336 44.554,53.266 46.311,55.838C48.098,58.456 51.836,59.652 54.274,57.464",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.129,43.589C38.876,43.811 36.544,45.621 35.967,48.682C35.38,51.798 37.176,55.286 40.448,55.463",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.499,30.383C55.682,30.783 59.559,35.31 59.159,40.493C58.758,45.676 54.232,49.554 49.049,49.154C43.866,48.753 39.989,44.227 40.389,39.043C40.789,33.86 45.316,29.982 50.499,30.383Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5,40C89.5,18.199 71.801,0.5 50,0.5C28.199,0.5 10.5,18.199 10.5,40C10.5,61.801 28.199,79.5 50,79.5C71.801,79.5 89.5,61.801 89.5,40Z",
    style: {
      fill: "none",
      stroke: "rgb(232,237,240)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeMiterlimit: 4
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLudzie);
export default __webpack_public_path__ + "static/media/ludzie.7ce2c10c.svg";
export { ForwardRef as ReactComponent };